import { Page } from 'corso-admin-ui';
import { crewClaimTypeEnumPluralizedName } from 'corso-types';
import SearchTable from '~/components/searchTable/SearchTable';
import { usePathParams } from '~/hooks/usePathParams';
import { useStoreId } from '~/providers/StoreUserProvider';
import { claimParamsSchema } from './claimParamsSchema';

export default function ClaimsTablePage() {
  const { claimType } = usePathParams(claimParamsSchema);
  const storeId = useStoreId();

  return (
    <Page
      title={crewClaimTypeEnumPluralizedName[claimType]}
      size="fullWidth"
      primaryAction={{
        to: `/${storeId}/orders/lookup`,
        content: 'Order Lookup',
      }}
    >
      <SearchTable />
    </Page>
  );
}
